import { gql } from "@apollo/client";

export const DELETE_INITIATIVE = gql`
  mutation Mutation($initiativeId: String!, $organizationId: String!) {
    deleteInitiative(initiativeId: $initiativeId, organizationId: $organizationId) {
      success
    }
  }
`;
